// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-meal-js": () => import("./../../../src/pages/meal.js" /* webpackChunkName: "component---src-pages-meal-js" */),
  "component---src-pages-stackys-js": () => import("./../../../src/pages/stackys.js" /* webpackChunkName: "component---src-pages-stackys-js" */)
}

